import React from 'react'
import { Flex, Typography } from 'components'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from 'services/slices/auth'
import { QuestionMenu } from './QuestionMenu/QuestionMenu'
import { Starter } from './Starter'
import { assistants } from '../assistants'
import { WordShuffle } from './WordShuffle'
import { useAIContext } from '../context/AIProvider'
import { useTranslation } from 'utils/useTranslation'

export const Homepage: React.FC = () => {
  const { t } = useTranslation('pages.ai')
  const user = useSelector(selectCurrentUser)
  const { shuffled, setShuffled, setPage } = useAIContext()

  return (
    <Flex
      directionColumn="zero"
      fullHeight
      gap={2}
      style={{
        padding: '1.5rem 5%',
        position: 'relative',
        justifyContent: 'center',
      }}
    >
      <Typography
        align="center"
        className="fade-in jetbrains-mono"
        fontSize="text_lg"
        fontWeight="medium"
        color="grey900"
      >
        {!shuffled
          ? user && (
              <WordShuffle onShuffleEnd={() => setShuffled(true)}>
                {t('hello_message', { username: user.username })}
              </WordShuffle>
            )
          : `Hello, ${user?.username ?? ''}. What would you like to know about?`}
      </Typography>
      <QuestionMenu />
      <Typography
        align="center"
        className="fade-in jetbrains-mono"
        fontSize="text_md"
        fontWeight="medium"
        color="grey900"
      >
        {t('or_chat')}
      </Typography>
      <div
        className="fade-in"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(1, 1fr)',
          gap: 16,
        }}
      >
        {assistants.map((assistant) => (
          <Starter
            onClick={() => setPage(assistant.action)}
            key={assistant.action}
            title={assistant.title}
            description={assistant.description}
            icon={assistant.icon}
            color={assistant.color}
          />
        ))}
      </div>
    </Flex>
  )
}
